import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";

const store = configureStore({
  reducer: rootReducer,
  // devTools: false  // TODO: to hide this framework on wappalyzer detection
})

export default store  